import React from 'react';

/**
 * Component to display an "external" svg icon
 * @param {*} props - Generic parameter to pass along any desired props to the component
 */
const SvgOpenExternal = (props) => (
  <svg
    id="OpenExternal"
    x={0}
    y={0}
    viewBox="0 0 23.08 22.4"
    xmlSpace="preserve"
    width="1em"
    height="1em"
    {...props}>
    <style></style>
    <path
      fill="currentColor"
      d="M22.7,2.4V20c0,1.3-1.1,2.4-2.4,2.4H2.7c-1.3,0-2.4-1.1-2.4-2.4V2.4
	C0.3,1.1,1.4,0,2.7,0h0h17.6C21.7,0,22.7,1.1,22.7,2.4z M18.3,3.2h-5.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.3,0.1,0.6,0.3,0.8l1.6,1.6
	l-9.8,9.8c-0.2,0.2-0.2,0.6,0,0.8L5.3,19c0.2,0.2,0.6,0.2,0.8,0l9.8-9.8l1.6,1.6c0.5,0.5,1.2,0.5,1.7,0c0.2-0.2,0.3-0.5,0.3-0.8V4.4
	C19.5,3.7,19,3.2,18.3,3.2C18.3,3.2,18.3,3.2,18.3,3.2L18.3,3.2z"
    />
  </svg>
);

export default SvgOpenExternal;
